package er.prateek.crossly.notifications

actual object NotificationSchedulerProvider {
    actual val scheduler: LocalNotificationScheduler = NoOpLocalNotificationScheduler
}

actual object NotificationPermissionProvider {
    actual val controller: NotificationPermissionController = UnsupportedNotificationPermissionController
}
